<template>
  <div class="contents">
    <div class="d-flex section-title">
      <img src="@/assets/images/Icon awesome-chalkboard_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">授業</p>
      <button class="btn-image ml-auto" :disabled="currentBusyState">
        <img src="@/assets/images/Button refresh.png" alt="" width="27.3" height="27.3" @click="reloadAskTeachers" />
      </button>
    </div>

    <!--tab-->
    <ul class="nav nav-tabs">
      <li class="d-flex nav-item" id="inclass_tab_menu">
        <a
          class="nav-link tabitem nav-cursor"
          :class="{ active: currentTab == TABS.INCLASS_TAB }"
          @click="selectTab(TABS.INCLASS_TAB)"
        >
          先生に聞く（授業中）
        </a>
        <span class="dot float-right" :class="showSingleDot(TABS.INCLASS_TAB) ? 'single' : 'multiple'">
          {{ totalInClassAskTeachers }}
        </span>
      </li>
      <li class="d-flex nav-item" id="inclass_tab_menu">
        <a
          class="nav-link tabitem nav-cursor"
          :class="{ active: currentTab == TABS.OUT_OF_CLASS_TAB }"
          @click="selectTab(TABS.OUT_OF_CLASS_TAB)"
        >
          先生に聞く（授業外）
        </a>
        <span class="dot float-right" :class="showSingleDot(TABS.OUT_OF_CLASS_TAB) ? 'single' : 'multiple'">
          {{ totalOutClassAskTeachers }}
        </span>
      </li>
      <li class="d-flex nav-item" id="inclass_tab_menu">
        <a
          class="nav-link tabitem nav-cursor"
          :class="{ active: currentTab == TABS.NOTIFY_TAB }"
          @click="selectTab(TABS.NOTIFY_TAB)"
        >
          先生に通知（強制）
        </a>
        <span class="dot float-right" :class="showSingleDot(TABS.NOTIFY_TAB) ? 'single' : 'multiple'">
          {{ totalNotificationAskTeachers }}
        </span>
      </li>
      <li class="d-flex nav-item" id="inclass_tab_menu">
        <a
          class="nav-link tabitem nav-cursor"
          :class="{ active: currentTab == TABS.HISTORY_TAB }"
          @click="selectTab(TABS.HISTORY_TAB)"
        >
          履歴
        </a>
      </li>
    </ul>
    <div class="container">
      <form class="d-flex form-inline">
        <button type="button" class="btn-sm" @click="clearFilteredByClass">全員を表示</button>
        <v-select
          tag="div"
          v-model="selectedTamaiClassId"
          placeholder="クラスを選択 / 検索して表示"
          class="form-control"
          id="dropdownMenuButton"
          :options="teacher.tamaiClasses"
          :reduce="(option) => option.id"
          label="nameReading"
        />
        <div class="form-group ml-auto">
          <label for="text1">検索:</label>
          <input type="text" id="searchform_small" class="form-control" v-model="filter" />
        </div>
      </form>

      <div class="tab-content">
        <div id="table-1" class="tab-pane active">
          <div class="table-wrapper-scroll-y">
            <b-table
              ref="ask-teacher-table"
              responsive
              class="sticky-table"
              sticky-header
              :items="currentAskTeachers"
              :fields="filteredHeaders"
              :filter="filter"
              :filterIncludedFields="searchableFields"
              :per-page="currentPerPage"
              :current-page="currentPage"
              :busy="currentBusyState"
              :refreshed="tableRefreshed()"
            >
              <template v-slot:head()="scope">
                <div class="text-nowrap">
                  <b>{{ scope.label }}</b>
                </div>
              </template>

              <template v-slot:cell(bookChapterAndBigQuestion)="row">
                <p v-if="isNotification(row.item.askedContext)">
                  {{ row.value }}
                </p>
                <a v-else class="hyper-text" @click="showAskTeacherDetail(row.item.id)">
                  {{ row.value }}
                </a>
              </template>

              <template v-slot:cell(correspondence)="row">
                <div class="table-sticky-right-column" v-if="inHistoryTab">
                  <div class="handle-status">{{ row.value }}</div>
                </div>
                <div class="table-sticky-right-column" v-else>
                  <ClassAskTeacherAction
                    :ask-teacher="row.item"
                    :ask-teachers="currentAskTeachers"
                    :show-self-solved-button="inClassTab || inOutClassTab"
                  />
                </div>
              </template>

              <template v-slot:table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>データのロード...</strong>
                </div>
              </template>
            </b-table>
          </div>
        </div>
      </div>
      <PopUpHolder ref="popup_holder" no-close-on-esc no-close-on-backdrop custom-footer popup-size="xl">
        <template v-slot:header>
          <span class="book-popup-header">{{ currentAskTeacherBookNameDisplay }}</span>
          <span class="book-popup-header">{{ currentAskTeacherBookPartDisplay }}</span>
          <span class="book-popup-header">{{ currentAskTeacherBookChapterAndBigQuestionDisplay }}</span>
          <button type="button" class="btn btn-gray-round float-right" @click="hidePopup">閉じる</button>
        </template>

        <template v-slot:footer>
          <ClassAskTeacherAction
            :ask-teacher="currentAskTeacher"
            :ask-teachers="currentAskTeachers"
            :show-self-solved-button="shouldShowSelfSolvedButton()"
            button-type-big
            @taughtClick="hidePopup"
            @gaveAHintClick="hidePopup"
            @selfSolvedClick="hidePopup"
          />
        </template>
        <template v-slot:body>
          <div v-for="imageURL in currentAskTeacher.questionImages" :key="imageURL">
            <div
              v-if="imageURL && imageURL == currentAskTeacher.questionImages.c1ImageUrl"
              class="image-url-holder c1-area"
            >
              <span class="c1-text">正答</span>
              {{ dispText(imageURL) }}
              <img
                class="c1-image"
                :class="'format_' + currentAskTeacher.bookSmallQuestion.format"
                :src="imageURL"
                v-if="!dispText(imageURL)"
              />
            </div>
            <img class="image-url-holder" :src="imageURL" v-else-if="imageURL" />
          </div>
        </template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ClassAskTeacherAction from '@/views/ask_teachers/forms/ClassAskTeacherAction.vue';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import { sumObjectArrayByKey } from '@/utils/math_helpers.js';
import { updateStickyColumnsAndMinWidth } from '@/helpers/sticky_table';
import { basicDatetime, basicFieldPresent, basicSubFieldPresent } from '@/presenters/fields';

export default {
  components: {
    ClassAskTeacherAction,
    PopUpHolder,
  },
  data() {
    var fields = [
      {
        key: 'handledDatetime',
        label: '対応日時',
        sortable: true,
        enable: false,
        searchable: true,
        class: 'sticky-column left-sticky-column-1',
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.dateTimeDisplay(value);
        },
      },
      {
        key: 'askedDatetime',
        label: '日時',
        sortable: true,
        enable: true,
        searchable: true,
        class: 'sticky-column left-sticky-column-2',
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.dateTimeDisplay(value);
        },
      },
      {
        key: 'student',
        label: '生徒名',
        sortable: true,
        enable: true,
        searchable: true,
        class: 'sticky-column left-sticky-column-3',
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.studentNameDisplay(value);
        },
      },
      {
        key: 'book',
        label: '教材',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 250 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.bookNameDisplay(value);
        },
      },
      {
        key: 'bookPartName',
        label: '分野',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 100 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return value;
        },
      },
      {
        key: 'bookChapterAndBigQuestion',
        label: '単元・大問',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 150 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return value;
        },
      },
      {
        key: 'school',
        label: '教場',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 200 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.schoolNameDisplay(value);
        },
      },
      {
        key: 'tamaiClass',
        label: 'クラス',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 200 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.classNameDisplay(value);
        },
      },
      {
        key: 'student',
        label: '生徒ID',
        sortable: true,
        enable: true,
        searchable: true,
        thAttr: { width: 200 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (value) => {
          return this.studentIdDisplay(value);
        },
      },
      {
        key: 'correspondence',
        label: '対応',
        sortable: false,
        enable: true,
        searchable: false,
        class: 'sticky-column right-sticky-column-1',
        thAttr: { width: 400 },
        sortByFormatted: true,
        filterByFormatted: true,
        formatter: (_v1, _v2, item) => {
          return this.correspondenceDisplay(item);
        },
      },
    ];
    const TABS = {
      INCLASS_TAB: 'in_class',
      OUT_OF_CLASS_TAB: 'out_class',
      NOTIFY_TAB: 'notification',
      HISTORY_TAB: 'history',
    };
    return {
      fields: fields,
      currentPage: 1,
      selectAll: false,
      TABS,
      currentTab: TABS.INCLASS_TAB,
      filter: null,
      inClassBusy: true,
      outClassBusy: false,
      notificationBusy: false,
      historyBusy: false,
      firstLoadOutClass: false,
      firstLoadNotification: false,
      firstLoadHistory: false,
      selectedTamaiClassId: null,
    };
  },
  computed: {
    inClassTab() {
      return this.currentTab == this.TABS.INCLASS_TAB;
    },
    inOutClassTab() {
      return this.currentTab == this.TABS.OUT_OF_CLASS_TAB;
    },
    inNotificationTab() {
      return this.currentTab == this.TABS.NOTIFY_TAB;
    },
    inHistoryTab() {
      return this.currentTab == this.TABS.HISTORY_TAB;
    },
    filteredHeaders() {
      return this.fields.filter((field) => field.enable == true);
    },
    searchableFields() {
      var fields = this.fields.filter((field) => field.enable == true && field.searchable == true);
      return fields.map((field) => field.key);
    },
    tableWidth() {
      return sumObjectArrayByKey(this.filteredHeaders, 'thAttr', 'width') + 'px';
    },
    currentAskTeachers() {
      let askTeachers = [];
      switch (this.currentTab) {
        case this.TABS.INCLASS_TAB:
          askTeachers = this.ask_teacher.inClassAskTeachers;
          break;
        case this.TABS.OUT_OF_CLASS_TAB:
          askTeachers = this.ask_teacher.outClassAskTeachers;
          break;
        case this.TABS.NOTIFY_TAB:
          askTeachers = this.ask_teacher.notificationAskTeachers;
          break;
        case this.TABS.HISTORY_TAB:
        default:
          askTeachers = this.ask_teacher.historyAskTeachers;
          break;
      }
      if (this.selectedTamaiClassId) {
        return askTeachers.filter((askTeacher) => {
          if (askTeacher.tamaiClass) {
            return askTeacher.tamaiClass.id == this.selectedTamaiClassId;
          }
          return false;
        });
      }
      return askTeachers;
    },
    currentAskTeacher() {
      return this.ask_teacher.askTeacher;
    },
    currentBusyState() {
      switch (this.currentTab) {
        case this.TABS.INCLASS_TAB:
          return this.inClassBusy;
        case this.TABS.OUT_OF_CLASS_TAB:
          return this.outClassBusy;
        case this.TABS.NOTIFY_TAB:
          return this.notificationBusy;
        case this.TABS.HISTORY_TAB:
        default:
          return this.historyBusy;
      }
    },
    currentPerPage() {
      switch (this.currentTab) {
        case this.TABS.INCLASS_TAB:
          return this.totalInClassAskTeachers;
        case this.TABS.OUT_OF_CLASS_TAB:
          return this.totalOutClassAskTeachers;
        case this.TABS.NOTIFY_TAB:
          return this.totalNotificationAskTeachers;
        case this.TABS.HISTORY_TAB:
        default:
          return this.totalHistoryAskTeachers;
      }
    },
    currentAskTeacherBookNameDisplay() {
      return basicSubFieldPresent(this.currentAskTeacher, 'book', 'name');
    },
    currentAskTeacherBookPartDisplay() {
      return basicSubFieldPresent(this.currentAskTeacher, 'bookPart', 'name');
    },
    currentAskTeacherBookChapterAndBigQuestionDisplay() {
      return basicFieldPresent(this.currentAskTeacher, 'bookChapterAndBigQuestion');
    },
    ...mapState(['ask_teacher']),
    ...mapState(['teacher']),
    ...mapGetters('ask_teacher', [
      'getInClassAskTeacherById',
      'getOutClassAskTeacherById',
      'getNotificationAskTeacherById',
      'getHistoryAskTeacherById',
      'totalInClassAskTeachers',
      'totalOutClassAskTeachers',
      'totalNotificationAskTeachers',
      'totalHistoryAskTeachers',
    ]),
  },
  mounted() {
    this.reloadInClass().finally(() => {
      this.firstLoadOutClassIfNeeded();
      this.firstLoadNotificationIfNeeded();
      this.firstLoadHistoryIfNeeded();
    });
  },
  methods: {
    tableRefreshed() {
      this.$logger.debug('Table refreshed');
      updateStickyColumnsAndMinWidth({ leftColumns: 3, rightColumns: 1 });
    },
    selectTab(tab) {
      this.$logger.debug('Select Tab:' + tab);
      this.currentTab = tab;

      switch (this.currentTab) {
        case this.TABS.INCLASS_TAB: {
          this.switchTitleWithKey('handledDatetime', false);
          break;
        }
        case this.TABS.OUT_OF_CLASS_TAB: {
          this.firstLoadOutClassIfNeeded();
          this.switchTitleWithKey('handledDatetime', false);
          break;
        }
        case this.TABS.NOTIFY_TAB: {
          this.firstLoadNotificationIfNeeded();
          this.switchTitleWithKey('handledDatetime', false);
          break;
        }
        case this.TABS.HISTORY_TAB: {
          this.firstLoadHistoryIfNeeded();
          this.switchTitleWithKey('handledDatetime', true);
          break;
        }
        default:
          this.switchTitleWithKey('handledDatetime', true);
          break;
      }
    },
    showSingleDot(tab) {
      switch (tab) {
        case this.TABS.INCLASS_TAB:
          return this.totalInClassAskTeachers < 10;
        case this.TABS.OUT_OF_CLASS_TAB:
          return this.totalOutClassAskTeachers < 10;
        case this.TABS.NOTIFY_TAB:
          return this.totalNotificationAskTeachers < 10;
        default:
          return this.totalHistoryAskTeachers < 10;
      }
    },
    showAskTeacherDetail(id) {
      this.showLoading();
      this.fetchAskTeacher(id).then(() => {
        this.$logger.debug('Show Ask Teacher Content from ID :' + id);
        this.$refs['popup_holder'].show();
      });
    },
    switchTitleWithKey(key, enabled) {
      const foundIndex = this.fields.findIndex((item) => item.key == key);
      this.$logger.debug('Switch Title: ' + this.fields[foundIndex].key + ' ' + enabled);
      this.fields[foundIndex].enable = enabled;
    },
    hidePopup() {
      this.$refs['popup_holder'].hide();
    },
    reloadAskTeachers() {
      this.reloadInClass();
      this.reloadOutClass();
      this.reloadNotification();
      this.reloadHistory();
    },
    refreshAskTeachers() {
      this.$logger.debug('Refresh table');
      this.$refs['ask-teacher-table'].refresh();
    },
    reloadInClass() {
      this.inClassBusy = true;
      this.$logger.debug('Reload In Class');
      this.clearInClassAskTeachers();
      return this.fetchInClassAskTeachers(this.TABS.INCLASS_TAB)
        .then(() => {
          this.inClassBusy = false;
          this.refreshAskTeachers();
        })
        .catch(() => {
          this.inClassBusy = false;
        });
    },
    firstLoadOutClassIfNeeded() {
      if (!this.firstLoadOutClass && !this.outClassBusy) {
        this.reloadOutClass();
      }
    },
    reloadOutClass() {
      this.outClassBusy = true;
      this.firstLoadOutClass = true;
      this.$logger.debug('Reload Out Class');
      this.clearOutClassAskTeachers();
      this.fetchOutClassAskTeachers(this.TABS.OUT_OF_CLASS_TAB)
        .then(() => {
          this.outClassBusy = false;
          this.refreshAskTeachers();
        })
        .catch(() => {
          this.outClassBusy = false;
        });
    },
    firstLoadNotificationIfNeeded() {
      if (!this.firstLoadNotification && !this.notificationBusy) {
        this.reloadNotification();
      }
    },
    reloadNotification() {
      this.notificationBusy = true;
      this.firstLoadNotification = true;
      this.$logger.debug('Reload Notification');
      this.clearNotificationAskTeachers();
      this.fetchNotificationAskTeachers(this.TABS.NOTIFY_TAB)
        .then(() => {
          this.notificationBusy = false;
          this.refreshAskTeachers();
        })
        .catch(() => {
          this.notificationBusy = false;
        });
    },
    firstLoadHistoryIfNeeded() {
      if (!this.firstLoadHistory && !this.historyBusy) {
        this.reloadHistory();
      }
    },
    reloadHistory() {
      this.historyBusy = true;
      this.firstLoadHistory = true;
      this.$logger.debug('Reload History');
      this.clearHistoryAskTeachers();
      this.fetchHistoryAskTeachers(this.TABS.HISTORY_TAB)
        .then(() => {
          this.historyBusy = false;
          this.refreshAskTeachers();
        })
        .catch(() => {
          this.historyBusy = false;
        });
    },
    bookNameDisplay(book) {
      return basicFieldPresent(book, 'name');
    },
    studentNameDisplay(student) {
      return basicFieldPresent(student, 'name');
    },
    studentIdDisplay(student) {
      return basicFieldPresent(student, 'uid');
    },
    schoolNameDisplay(school) {
      return basicFieldPresent(school, 'name');
    },
    classNameDisplay(tamaiClass) {
      return basicFieldPresent(tamaiClass, 'name');
    },
    dateTimeDisplay(field) {
      return basicDatetime(field);
    },
    correspondenceDisplay(item) {
      let answer = '';
      let prefix = this.isNotification(item.askedContext) ? '通知：' : '聞く：';

      switch (item.handledType) {
        case 'taught':
          answer = '教えた';
          break;
        case 'gave_a_hint':
          answer = 'ヒントをあげた';
          break;
        case 'self_solved':
          answer = '考え終えていた';
          break;
        default:
          break;
      }

      return prefix + answer;
    },
    clearFilteredByClass() {
      this.selectedTamaiClassId = null;
    },
    shouldShowSelfSolvedButton() {
      return this.currentAskTeacher.askedContext != 'notification';
    },
    isNotification(askedContext) {
      return askedContext == 'notification';
    },
    dispText(imageURL) {
      const isImage = imageURL.includes('.png');
      if (!isImage) {
        return imageURL.slice(3);
      } else {
        return null;
      }
    },
    ...mapActions('ask_teacher', [
      'clearInClassAskTeachers',
      'clearOutClassAskTeachers',
      'clearNotificationAskTeachers',
      'clearHistoryAskTeachers',
      'fetchInClassAskTeachers',
      'fetchOutClassAskTeachers',
      'fetchNotificationAskTeachers',
      'fetchHistoryAskTeachers',
      'fetchAskTeacher',
    ]),
    ...mapActions('loading', ['showLoading']),
  },
};
</script>

<style scoped>
.section-title {
  padding-bottom: 8px;
  max-width: 1140px;
}
.nav-tabs {
  border-width: 1px 1px 0px 1px;
  height: 46px;
  max-width: 1140px;
}
.tabitem {
  border-width: 1px 1px 0px 1px;
  margin-top: 16px;
  height: 29px;
}
.tabitem.active {
  border-width: 1px 1px 0px 1px;
  border-color: black;
  margin-top: 16px;
  height: 30px;
}
.container {
  border-radius: 0px 0px 3px 3px;
  padding-top: 12px;
  padding-bottom: 12px;
}
.nav-cursor {
  cursor: pointer;
}
.dot {
  height: 14px;
  width: 14px;
  background-color: red;
  border-radius: 50%;
  display: inline-block;
  font-size: 9px;
  margin-top: 9px;
  margin-left: -11px;
  color: white;
  text-align: center;
  display: table;
}
.single {
  padding: 2px 6px 2px 6px;
}
.multiple {
  padding: 2px 3px 2px 3px;
}
.btn-image {
  padding-right: 0px;
}
.btn-sm {
  margin-left: 0px;
  margin-right: 10px;
}
.handle-status {
  width: 240px;
}
.hyper-text {
  color: #227afa;
  cursor: pointer;
}
.btn-gray-round {
  margin-left: 20px;
  box-shadow: none;
  border: none;
  background-color: gray;
  color: white;
  border-radius: 7px;
  padding: 6px 26px;
  margin-bottom: 10px;
  margin-right: 10px;
}
.book-popup-header {
  margin-right: 40px;
}
.image-url-holder {
  width: 65%;
  margin-bottom: 5px;
}
.c1-area {
  width: 80%;
  font-size: 30px;
}
.c1-text {
  vertical-align: top;
  margin-right: 10px;
  padding: 5px;
  border: 1.5px solid #e75e58;
  border-radius: 0.3rem;
}
.c1-image {
  width: 25%;
}
.format_fb4 {
  width: 20%;
}
.format_fa4 {
  width: 75%;
}
</style>
